module.exports = __webpack_public_path__ + "static/media/student.f47cecd1.svg";